export default {
    data: [
        'Đông',
        'Đông Bắc',
        'Đông Nam',
        'Tây',
        'Tây Bắc',
        'Tây Nam',
        'Nam',
        'Bắc'
    ]
}